import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export class CartState {
  public clinicId?: string;
  public procedureIds: string[] = [];
}

const getters: GetterTree<CartState, any> = {
  clinic(state: CartState) {
    return state.clinicId;
  },
  procedures(state: CartState) {
    return state.procedureIds;
  },
  uniqueProcedures(state: CartState) {
    return state.procedureIds.reduce(
      (dict, p) => ({
        ...dict,
        [p]: (dict[p] || 0) + 1,
      }),
      {} as { [index: string]: number }
    );
  },
  isEmpty(state: CartState) {
    return state.procedureIds.length < 1;
  },
};

const mutations: MutationTree<CartState> = {
  changeClinic(state, clinicId: string) {
    if (state.clinicId === clinicId) {
      return;
    }

    state.clinicId = clinicId;
    state.procedureIds = [];
  },
  addProcedure(state, procedureId: string) {
    state.procedureIds.push(procedureId);
  },
  removeProcedure(state, procedureId: string) {
    const index = state.procedureIds.indexOf(procedureId);
    if (index < 0) {
      return;
    }

    state.procedureIds.splice(index, 1);
  },
  clear(state) {
    state.procedureIds = [];
    state.clinicId = undefined;
    localStorage.removeItem('cart');
  },
  save(state) {
    localStorage.setItem('cart', JSON.stringify(state));
  },
};

const actions: ActionTree<CartState, any> = {
  changeClinic(store, clinicId: string) {
    store.commit('changeClinic', clinicId);
    store.commit('save');
  },
  addProcedure(store, procedureId: string) {
    store.commit('addProcedure', procedureId);
    store.commit('save');
  },
  removeProcedure(store, procedureId: string) {
    store.commit('removeProcedure', procedureId);
    store.commit('save');
  },
  clear(store) {
    store.commit('clear');
  },
};

export default {
  namespaced: true,
  state: () => {
    const state = new CartState();
    const stored = JSON.parse(localStorage.getItem('cart') || '{}');
    return Object.assign(state, stored);
  },
  getters,
  mutations,
  actions,
};
